import React,{Fragment} from 'react';
import Search from '../Users/Search';
import User from '../Users/User';

const Home = ()=>  <Fragment>
    <Search/>
    <User/>
  </Fragment>


export default Home;